import { EnvironmentProviders, importProvidersFrom } from '@angular/core';
import { RouterModule } from '@angular/router';
import { routes } from './app.routes';

export function provideRouter(): EnvironmentProviders {
  return importProvidersFrom(RouterModule.forRoot(routes));
}
